export enum ModalRole {
  MODAL_WARN = 'warn',
  MODAL_INFO = 'info',
  MODAL_DANGER = 'danger',
}
